<div
  class="fdx-c-form-group fdx-c-form-group--float-label fdx-c-form-group--has-value"
  [ngClass]="{
    'fdx-c-form-group--is-invalid': isControlTouchedAndInvalid(formField),
  }"
  role="combobox">
  <span class="fdx-c-form-group__item">
    <ng-content></ng-content>
    <label
      class="fdx-c-form-group__label fdx-c-form-group__label--dark fdx-u-px--4"
      for="INPUT"
      id="ITEMLABEL"
      >Wyszukaj punkt *</label
    >
  </span>

  <app-form-field-error-messages [formField]="formField">
  </app-form-field-error-messages>

  @if (isDropdownVisible && isElementFocused) {
  <ul
    class="fdx-c-autocomplete"
    style="
      max-height: 200px;
      overflow-y: auto;
      border: 1px solid #ccc;
      padding: 0;
      margin: 0;
    "
    id="ADDRESS-LIST"
    role="listbox"
    aria-hidden="false"
    (scroll)="onScroll($event)">
    <li
      role="option"
      aria-disabled="true"
      style="pointer-events: none; opacity: 0.6">
      <div class="fdx-o-grid__row fdx-o-grid__item--12">
        <div class="fdx-o-grid__item--3">
          <span class="fdx-c-paragraph fdx-c-paragraph--small">PUNKT</span>
        </div>
        <div class="fdx-o-grid__item--3">
          <span class="fdx-c-paragraph fdx-c-paragraph--small">NAZWA</span>
        </div>
        <div class="fdx-o-grid__item--2">
          <span class="fdx-c-paragraph fdx-c-paragraph--small"
            >KOD POCZTOWY</span
          >
        </div>
        <div class="fdx-o-grid__item--2">
          <span class="fdx-c-paragraph fdx-c-paragraph--small"
            >MIEJSCOWOŚĆ</span
          >
        </div>
        <div class="fdx-o-grid__item--2">
          <span class="fdx-c-paragraph fdx-c-paragraph--small">ADRES</span>
        </div>
      </div>
    </li>
    <li
      *ngFor="let item of items"
      role="option"
      (mousedown)="onItemClick(item)">
      <div class="fdx-o-grid__row fdx-o-grid__item--12">
        <div class="fdx-o-grid__item--3">
          <span class="fdx-c-paragraph fdx-c-paragraph--small">{{
            item.pointCode
          }}</span>
        </div>
        <div class="fdx-o-grid__item--3">
          <span class="fdx-c-paragraph fdx-c-paragraph--small">{{
            item.pointName
          }}</span>
        </div>
        <div class="fdx-o-grid__item--2">
          <span class="fdx-c-paragraph fdx-c-paragraph--small">{{
            item.postalCode
          }}</span>
        </div>
        <div class="fdx-o-grid__item--2">
          <span class="fdx-c-paragraph fdx-c-paragraph--small">{{
            item.city
          }}</span>
        </div>
        <div class="fdx-o-grid__item--2">
          <span class="fdx-c-paragraph fdx-c-paragraph--small">{{
            item.address1
          }}</span>
        </div>
      </div>
    </li>
    @if (isLoading) {
    <li role="option" aria-disabled="true" style="pointer-events: none">
      <div class="fdx-o-grid__row fdx-o-grid__item--12 fdx-o-grid__row--center">
        <div class="fdx-c-loader fdx-c-loader--medium"></div>
      </div>
    </li>
    }
  </ul>
  }
</div>
